// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutErrorModals-module__wrapper___3gxJP","paragraph":"CheckoutErrorModals-module__paragraph___2IbxO"};